export default __webpack_public_path__ + "static/media/Ies_Cooper.b4aa21bd.png";